import { FC } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Tooltip from "@mui/material/Tooltip";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface NewBtnProps {
  title?: string;
  hoverText?: string;
  handleOnClick: () => void;
  adding?: boolean;
}

const NewBtn: FC<NewBtnProps> = ({
  title,
  hoverText,
  handleOnClick,
  adding = true,
}) => {
  return (
    <Tooltip title={hoverText ?? ""}>
      <GeneralButton appVariant="icon" onClick={handleOnClick}>
        {title ?? (adding ? <AddIcon /> : <RemoveIcon />)}
      </GeneralButton>
    </Tooltip>
  );
};

export default NewBtn;

